var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options)?_c('div',{staticClass:"bg-slides"},_vm._l((_vm.getImages),function(image,index){return _c('div',{key:index,staticClass:"bg-cover",style:(_vm.getSlideStyle[index])})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }